// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27black%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .contactUs .container {
        margin-top: 50px;
    }

    .aRemove {
        color: #000;
    }

    .aRemove:hover {
        text-decoration: none;
    }

    #secondcon {
        display: none;
    }

    @media (width <= 600px) {
        .form-top-home .form {
            background-color: #2067d1;
            border-radius: 0;
            margin-top: 497px;
            padding: 20px;
        }

        .call-btn {
            display: none !important;
        }

        .main-slider {
            background-position: top !important;
            background-size: 100% !important;
        }

        .winter_fest_side {
            display: block !important;
        }

        .main-slider {
            background-size: 200% !important;
        }
    }

    @media (width <= 676px) {
        .listing-home .custom-nav-mobi .owl-prev,
        .listing-home .custom-nav-mobi .owl-next {
            background-color: #2067d1;
            color: white;
        }
    }

    .winter_fest_side {
        display: none;
    }
    
   
    .top-header p {
        color: #fff;
    }

    .top-header p i {
        color: #fff;
    }

    .card-im img {
        height: 250px;
        width: 100%;
        object-fit: cover;
        border-radius: 15px;
    }

    .blog .item img {
        height: 250px;
        width: 100%;
        object-fit: cover;
        border-radius: 15px;
    }

    .weWork .headline .sub-headline {
        font-size: 20px;
        letter-spacing: 3px;
    }

    .card-im a {
        text-decoration: none;
    }

    .client_slider .owl-carousel .item img {
        padding: 5px;
    }

    .client_slider .headline .h3 {
        font-family: "Sofia Pro", sans-serif;
        font-size: 46px;
        text-align: center;
        font-weight: 700;
        color: #000;
    }

    .listing-home .listing-slide .card-im .list_headline_two {
        min-height: 80px;
    }

    .form-top-home select {
        appearance: none;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-repeat: no-repeat;
        background-position-x: 98%;
        background-position-y: 50%;
    }   

    *:focus {
        outline: none;
        box-shadow: none !important;
    }

    #projects {
        position: absolute;
    }

    .main-slider h1 {
        text-align: center;
        color: #fff;
        font-size: 60px;
        font-weight: 200;
    }

`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/Head.css"],"names":[],"mappings":";IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI;YACI,yBAAyB;YACzB,gBAAgB;YAChB,iBAAiB;YACjB,aAAa;QACjB;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,mCAAmC;YACnC,gCAAgC;QACpC;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,gCAAgC;QACpC;IACJ;;IAEA;QACI;;YAEI,yBAAyB;YACzB,YAAY;QAChB;IACJ;;IAEA;QACI,aAAa;IACjB;;;IAGA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,WAAW;QACX,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,oCAAoC;QACpC,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,yDAAsN;QACtN,4BAA4B;QAC5B,0BAA0B;QAC1B,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB","sourcesContent":["\n    .contactUs .container {\n        margin-top: 50px;\n    }\n\n    .aRemove {\n        color: #000;\n    }\n\n    .aRemove:hover {\n        text-decoration: none;\n    }\n\n    #secondcon {\n        display: none;\n    }\n\n    @media (width <= 600px) {\n        .form-top-home .form {\n            background-color: #2067d1;\n            border-radius: 0;\n            margin-top: 497px;\n            padding: 20px;\n        }\n\n        .call-btn {\n            display: none !important;\n        }\n\n        .main-slider {\n            background-position: top !important;\n            background-size: 100% !important;\n        }\n\n        .winter_fest_side {\n            display: block !important;\n        }\n\n        .main-slider {\n            background-size: 200% !important;\n        }\n    }\n\n    @media (width <= 676px) {\n        .listing-home .custom-nav-mobi .owl-prev,\n        .listing-home .custom-nav-mobi .owl-next {\n            background-color: #2067d1;\n            color: white;\n        }\n    }\n\n    .winter_fest_side {\n        display: none;\n    }\n    \n   \n    .top-header p {\n        color: #fff;\n    }\n\n    .top-header p i {\n        color: #fff;\n    }\n\n    .card-im img {\n        height: 250px;\n        width: 100%;\n        object-fit: cover;\n        border-radius: 15px;\n    }\n\n    .blog .item img {\n        height: 250px;\n        width: 100%;\n        object-fit: cover;\n        border-radius: 15px;\n    }\n\n    .weWork .headline .sub-headline {\n        font-size: 20px;\n        letter-spacing: 3px;\n    }\n\n    .card-im a {\n        text-decoration: none;\n    }\n\n    .client_slider .owl-carousel .item img {\n        padding: 5px;\n    }\n\n    .client_slider .headline .h3 {\n        font-family: \"Sofia Pro\", sans-serif;\n        font-size: 46px;\n        text-align: center;\n        font-weight: 700;\n        color: #000;\n    }\n\n    .listing-home .listing-slide .card-im .list_headline_two {\n        min-height: 80px;\n    }\n\n    .form-top-home select {\n        appearance: none;\n        background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n        background-repeat: no-repeat;\n        background-position-x: 98%;\n        background-position-y: 50%;\n    }   \n\n    *:focus {\n        outline: none;\n        box-shadow: none !important;\n    }\n\n    #projects {\n        position: absolute;\n    }\n\n    .main-slider h1 {\n        text-align: center;\n        color: #fff;\n        font-size: 60px;\n        font-weight: 200;\n    }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
